module.exports = __webpack_public_path__ + "img/signal_wifi_statusbar_4_bar_26x24px.5ad94aba.svg";